module.exports = "<p>\r\n  reports works!\r\n</p>\r\n"